<template>
  <!-- このコンポーネントは社内限定で使用する為に作成ました。-->
  <!-- 他機能の実装や改修などでこのコンポーネントを使用しないでください。 -->
  <!-- 使用したら爆散しますよ。 -->
  <div class="px-3 pb-5">
    <div class="py-4">
      作品URL末尾の識別コードを入れてください。<br />
      例
      http://share.clip-studio.com/ja-jp/contents/7aacb6e5-d0ad-4e09-a99b-076ce7c54800?at=1580718312
      <br />
      このURLの場合、「contents/」以降の「7aacb6e5-d0ad-4e09-a99b-076ce7c54800」が識別コード（?から始まる?at=1580718312は除く）<br />
      例
      http://local-share.clip-studio.com:23590/ja-jp/contents/view?code=7aacb6e5-d0ad-4e09-a99b-076ce7c54800<br />
      このURLの場合、「code=XXXX」のXXXXが識別コードなので「7aacb6e5-d0ad-4e09-a99b-076ce7c54800」です。
    </div>
    <v-text-field
      outline
      single-line
      label="作品コード"
      v-model="identificationCode"
      :value="identificationCode"
    ></v-text-field>
    <div class="text-xs-center pb-3">
      <v-btn @click="onClickGetContentsPageList"> 作品の画像を取得する </v-btn>
    </div>

    <div v-if="!isNothingContentsData">
      <h3 class="pb-3">作品タイトル : {{ contentsTitle }}</h3>
      <div :class="[$style.listImages, 'px-4', 'pb-4']">
        <div
          v-for="(image, index) in contentsPageImages"
          :key="index"
          :class="$style.listImages__listImageWrapper"
        >
          <div
            :class="$style.listImages__listImage"
            :style="[
              {
                'background-color': 'white',
                'background-size': 'contain',
                'background-position': 'center',
                'background-image':
                  'url(' + contentsPageImages[index].dataUrl + ')'
              },
              imageSize
            ]"
          ></div>
          <div class="text-xs-center pt-2">
            <span>{{ index + 1 }}</span>
          </div>
        </div>
      </div>

      <div class="text-xs-center">
        <p class="mb-0">全{{ contentsAllPageCount }}ページ</p>
        <v-btn @click="saveImages"> 画像を保存する </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { doUnscramble } from "../../../lib/unscramble";
import log from "loglevel";

export default {
  name: "vc-share-save-contents-images",
  props: {
    lang: {
      type: Object,
      default: () => ({
        image_indicate: "リンクを設定するページを選ぶ",
        image_indicate_desc: "エリアを選択後にリンク先を入力してください。",
        url: "URL",
        page_in_contents: "作品内のページ",
        select_page: "ページ選択",
        page: ":page_num",
        delete: "選択したエリアをクリア",
        apply: "適用",
        preview_create: "プレビューを作成する",
        preview_view: "プレビューを表示する",
        release: "保存",
        destination_page: "ページ :selected_num / :max_num",
        error_no_page_selected: "ページを選択してください。"
      })
    },

    // stateToProps
    isBusy: {
      type: Boolean,
      default: false
    },

    // actionsToProps
    getContentsPageList: {
      type: Function,
      default: () => {}
    },

    // mutationsToProps
    setIsBusy: {
      type: Function,
      default: () => {}
    }
  },
  data: () => ({
    contentsTitle: "",
    identificationCode: "",
    // 画像と画像のスクランブル解除に必要な変数
    contentsPageImages: [],
    contentsAllPageCount: 0,
    draftId: 0,
    scrambleWidth: 0,
    scrambleHeight: 0,
    resolution: 8, // スクランブル解除時の固定パラメーター
    isNothingContentsData: true,
    originX: 0,
    originY: 0,
    downloadLink: ""
  }),
  methods: {
    onClickGetContentsPageList() {
      this.setIsBusy(true);

      this.getContentsPageList({
        identificationCode: this.identificationCode
      }).then(res => {
        if (res.status !== 0) {
          this.setIsBusy(false);
          return;
        }

        this.contentsTitle = res.contentsTitle;
        this.scrambleWidth = res.scrambleWidth;
        this.scrambleHeight = res.scrambleHeight;
        this.contentsAllPageCount = res.imageUrls.length;
        this.$nextTick(() => this.unscrambleImages(res.imageUrls));
      });
    },
    unscrambleImages(images) {
      const tasks = [];
      images.forEach((image, index) => {
        tasks.push(
          new Promise((resolve, reject) => {
            try {
              const tmpImageElement = new Image();
              tmpImageElement.crossOrigin = "Anonymous";
              tmpImageElement.src = image.imageUrl;
              const tmpCanvasElement = document.createElement("canvas");
              tmpImageElement.onload = () => {
                doUnscramble(
                  image.scramble,
                  this.scrambleWidth,
                  this.scrambleHeight,
                  this.resolution,
                  tmpImageElement,
                  tmpCanvasElement
                );
                image.dataUrl = tmpCanvasElement.toDataURL();
                tmpCanvasElement.toBlob(blob => {
                  const url = URL.createObjectURL(blob);
                  image.src = url;
                  image.onload = () => {
                    URL.revokeObjectURL(url);
                  };
                });
                this.contentsPageImages[index] = image;
                resolve();
              };
            } catch (e) {
              reject(e);
            }
          })
        );
      });
      Promise.all(tasks)
        .then(() => {
          this.setIsBusy(false);
          this.isNothingContentsData = false;
        })
        .catch(error => {
          log.error("error:", error);
        });
    },
    saveImages() {
      this.contentsPageImages.forEach((image, index) => {
        const linkClick = () => {
          console.log("index: ", index);
          const linkElement = document.createElement("a");
          const pageCount = ("000" + (index + 1)).slice(-3);
          document.body.appendChild(linkElement);
          linkElement.href = image.src;
          linkElement.download =
            this.identificationCode + "_" + pageCount + ".png";
          linkElement.dataset.imageDownloadLink = "";
          linkElement.click();
          document.body.removeChild(linkElement);
        };

        // forEach 内の処理は並列処理になる
        // 回数が重なると同時実行になって click() が正常に動作しなかったのでずらす
        setTimeout(() => {
          linkClick();
        }, index * 100);
      });
    }
  },
  computed: {
    imageSize() {
      return { width: "118px", height: "172px" };
    }
  }
};
</script>

<style module lang="scss">
.listImages {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;

  &__border {
    border: 1px solid blue;
  }
  &__listImageWrapper {
    position: relative;
  }
  &__listImage {
    border: black solid 1px;
  }
}
</style>
